import { RadioGroup, View } from "@/components/ui";
import { Clock } from "@/components/shared/icons";
import { ListHeading } from "@/components/shared/list-header";
import type { FrequencyOption } from "@/components/shared/service-radio-item/types";
import { SectionServiceRadio } from "./section-service-radio";
import { Grid } from "@/components/shared/grid";

export function SectionSelectServices({
  selectedFrequencyOption,
  frequencyOptions,
  onChooseFrequency,
}: {
  selectedFrequencyOption: FrequencyOption;
  frequencyOptions: FrequencyOption[];
  onChooseFrequency(item: FrequencyOption): void;
}) {
  return (
    <View className="flex flex-col gap-4 pb-2 pt-4">
      <ListHeading title="Choose Cleaning Frequency" icon={Clock} />
      <RadioGroup
        value={selectedFrequencyOption.title}
        onValueChange={(value) => {
          const item = frequencyOptions.find((i) => i.title === value);
          if (item) onChooseFrequency(item);
        }}
      >
        <Grid
          data={frequencyOptions}
          columns={3}
          gap={12}
          render={(item) => (
            <SectionServiceRadio
              key={item.title}
              item={item}
              selected={selectedFrequencyOption.title === item.title}
              onSelect={() => onChooseFrequency(item)}
            />
          )}
        />
      </RadioGroup>
    </View>
  );
}
